// Fix: prevent auto-scroll to reviews on page load
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

// Zoom Animation Js

    document.addEventListener('DOMContentLoaded', function() {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2 
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible'); 
          }
        });
      }, observerOptions);

      const circles = document.querySelectorAll('.zoom-trigger');
      circles.forEach(circle => {
        observer.observe(circle);
      });
    });


    // Product Slider and Cart Butoon
      document.addEventListener('DOMContentLoaded', function() {
    
    // Elements
    const mainViewport = document.getElementById('custom-main-viewport');
    const thumbViewport = document.getElementById('custom-thumbs-viewport');
    const track = document.querySelector('.custom-thumbs-track');
    const prevBtn = document.getElementById('custom-thumb-prev');
    const nextBtn = document.getElementById('custom-thumb-next');
    const thumbs = document.querySelectorAll('.custom-thumb');
    const dots = document.querySelectorAll('.custom-dot');

    const thumbScrollAmount = 102; // 90px thumb + 12px gap
    let isAnimating = false; // Prevents spam-clicking from breaking the layout
    
    // Function to update Active states (Blue border and dots)
    function updateActiveState(index) {
      document.querySelectorAll('.custom-thumb').forEach(t => t.classList.remove('is-active'));
      dots.forEach(d => d.classList.remove('is-active'));
      
      const activeThumb = document.querySelector(`.custom-thumb[data-index="${index}"]`);
      if(activeThumb) activeThumb.classList.add('is-active');
      if(dots[index]) dots[index].classList.add('is-active');
    }

    // 1. Thumbnail Click Event (Updates main image)
    document.addEventListener('click', function(e) {
      const thumb = e.target.closest('.custom-thumb');
      if (!thumb) return;
      
      const index = parseInt(thumb.getAttribute('data-index'));
      updateActiveState(index);
      
      if(mainViewport) {
        mainViewport.scrollTo({ left: index * mainViewport.clientWidth, behavior: 'smooth' });
      }
    });

    // 2. Dot Click Event (Mobile)
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-index'));
        updateActiveState(index);
        
        if(mainViewport) {
          mainViewport.scrollTo({ left: index * mainViewport.clientWidth, behavior: 'smooth' });
        }
      });
    });

if(mainViewport) {
      // 1. Keep your existing mobile/trackpad scroll listener
      mainViewport.addEventListener('scroll', () => {
        let index = Math.round(mainViewport.scrollLeft / mainViewport.clientWidth);
        updateActiveState(index);
      });

      // 2. Updated SMOOTH Desktop Click-and-Drag Logic
      let isDown = false;
      let startX;
      let scrollLeft;

      mainViewport.style.cursor = 'grab';

      mainViewport.addEventListener('mousedown', (e) => {
        isDown = true;
        mainViewport.style.cursor = 'grabbing';
        
        // CRITICAL: Turn off smooth scroll & snapping so the drag is instantly 1:1 with your mouse
        mainViewport.style.scrollBehavior = 'auto'; 
        mainViewport.style.scrollSnapType = 'none'; 
        
        startX = e.pageX - mainViewport.offsetLeft;
        scrollLeft = mainViewport.scrollLeft;
      });

      // Handle when the user lets go of the mouse OR drags out of the image area
      const stopDragging = () => {
        if (!isDown) return;
        isDown = false;
        mainViewport.style.cursor = 'grab';
        
        // Turn smooth scrolling and snapping back on
        mainViewport.style.scrollBehavior = 'smooth';
        mainViewport.style.scrollSnapType = 'x mandatory'; 

        // Calculate the closest image and force a smooth glide to perfectly center it
        const index = Math.round(mainViewport.scrollLeft / mainViewport.clientWidth);
        mainViewport.scrollTo({ left: index * mainViewport.clientWidth, behavior: 'smooth' });
      };

      mainViewport.addEventListener('mouseleave', stopDragging);
      mainViewport.addEventListener('mouseup', stopDragging);

      mainViewport.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault(); 
        
        const x = e.pageX - mainViewport.offsetLeft;
        const walk = (x - startX) * 1.5; // Drag speed multiplier
        mainViewport.scrollLeft = scrollLeft - walk;
      });
    }
    // 4. Infinite Thumbnail Slider (DOM Shifting)
    if (prevBtn && nextBtn && track) {
      
      // Remove disabled attributes if they exist
      prevBtn.removeAttribute('disabled');
      nextBtn.removeAttribute('disabled');

      nextBtn.addEventListener('click', () => {
        if (isAnimating || track.children.length <= 1) return;
        isAnimating = true;
        
        // Slide up smoothly
        track.style.transition = 'transform 0.3s ease-in-out';
        track.style.transform = `translateY(-${thumbScrollAmount}px)`;
        
        // Wait for slide to finish, then move top element to the bottom
        setTimeout(() => {
          track.style.transition = 'none';
          track.appendChild(track.firstElementChild); 
          track.style.transform = 'translateY(0)';
          isAnimating = false;
        }, 300);
      });

      prevBtn.addEventListener('click', () => {
        if (isAnimating || track.children.length <= 1) return;
        isAnimating = true;
        
        // Move bottom element to the top instantly, offset the track, then slide down
        track.style.transition = 'none';
        track.prepend(track.lastElementChild);
        track.style.transform = `translateY(-${thumbScrollAmount}px)`;
        
        // Force browser to register the new position before animating
        void track.offsetHeight;
        
        track.style.transition = 'transform 0.3s ease-in-out';
        track.style.transform = 'translateY(0)';
        
        setTimeout(() => {
          isAnimating = false;
        }, 300);
      });
    }

    // AJAX Add to Cart Logic (Unchanged)
    // Pre-order products are handled by PreProduct's native-button takeover
    // (different form id + a [data-native-pre-order-btn] button). Exclude them here
    // so this AJAX handler never opens the cart drawer for a pre-order add.
    const ajaxForms = Array.from(document.querySelectorAll('#custom-ajax-cart-form'))
      .filter(form => !form.querySelector('[data-native-pre-order-btn]'));
    if (ajaxForms) {
      ajaxForms.forEach (ajaxForm => ajaxForm.addEventListener('submit', function(e) {
        e.preventDefault();
        const submitBtn = ajaxForm.querySelector('.btn-custom-add');
        const btnText = submitBtn.querySelector('.btn-text');
        const originalText = btnText.innerHTML;

        btnText.innerHTML = 'Adding...';
        submitBtn.disabled = true;

        let formData = new FormData(ajaxForm);
        formData.append('sections', 'cart-drawer');
        formData.append('sections_url', window.location.pathname);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (!response.ok) throw new Error('Network error');
          return response.json();
        })
        .then(data => {
          btnText.innerHTML = originalText;
          submitBtn.disabled = false;

          if (data.sections && data.sections['cart-drawer']) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data.sections['cart-drawer'];
            const newDrawerInner = tempDiv.querySelector('cart-drawer').innerHTML;
            const existingDrawer = document.getElementById('cart-drawer');
            
            if (existingDrawer) {
              existingDrawer.innerHTML = newDrawerInner;
              if (typeof existingDrawer.open === 'function') {
                existingDrawer.open();
              } else if (typeof existingDrawer.show === 'function') {
                existingDrawer.show();
              } else {
                existingDrawer.setAttribute('open', '');
              }
            }
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          btnText.innerHTML = 'Error';
          submitBtn.disabled = false;
          setTimeout(() => { window.location.href = '/cart'; }, 1000);
        });
      }));
    }
  });


//   Faq JS
    document.addEventListener('DOMContentLoaded', function() {
      // Select all accordion items
      const faqItems = document.querySelectorAll('.faq-accordion-item');

      faqItems.forEach((item) => {
        const question = item.querySelector('.faq-question');

        question.addEventListener('click', () => {
          // Check if the clicked item is currently open
          const isOpen = item.classList.contains('is-open');

          // First, close all other items for the accordion effect
          faqItems.forEach((otherItem) => {
            otherItem.classList.remove('is-open');
          });

          // If the clicked item wasn't open, open it
          if (!isOpen) {
            item.classList.add('is-open');

// Fix: scroll question to top of viewport
            setTimeout(function() {
              var headerHeight = document.querySelector('header')?.offsetHeight || 100;
              var offset = question.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
              window.scrollTo({ top: offset, behavior: 'smooth' });
            }, 300);
          }
        });
      });
    });

// ============================================================
// EmpiriVita: keep PreProduct's cart session in sync with the Shopify cart.
// When pre-order lines are removed from the drawer and none remain, clear
// PreProduct's PPcartSession so its launcher/count + reserved units release.
// Uses PreProduct's own documented API (PPcartSession.clear) only.
// ============================================================
(function () {
  var syncing = false;
  function syncPreProductSession() {
    if (syncing || !window.Shopify || !window.Shopify.routes) return;
    syncing = true;
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasPreorder = (cart.items || []).some(function (it) {
          var alloc = it.selling_plan_allocation;
          var planName = ((alloc && alloc.selling_plan && alloc.selling_plan.name) || '').toLowerCase();
          return planName.indexOf('pre-order') !== -1 || planName.indexOf('preorder') !== -1;
        });
        if (!hasPreorder && window.PPcartSession && typeof window.PPcartSession.clear === 'function') {
          window.PPcartSession.clear();
        }
      })
      .catch(function () {})
      .finally(function () { syncing = false; });
  }

  var debounce;
  function scheduleSync() { clearTimeout(debounce); debounce = setTimeout(syncPreProductSession, 350); }

  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('cart:change', scheduleSync);

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(scheduleSync).observe(drawer, { childList: true, subtree: true });
  });
})();
document.addEventListener("DOMContentLoaded", function () {
  var v = document.getElementById("custom-main-viewport");
  if (!v) return;
  function toFirst() {
    var p = v.style.scrollBehavior;
    v.style.scrollBehavior = "auto";
    v.scrollLeft = 0;
    v.style.scrollBehavior = p || "smooth";
    document.querySelectorAll(".custom-thumb, .custom-dot").forEach(function (t) {
      t.classList.remove("is-active");
    });
    var t0 = document.querySelector('.custom-thumb[data-index="0"]');
    if (t0) t0.classList.add("is-active");
    var d0 = document.querySelector('.custom-dot[data-index="0"]');
    if (d0) d0.classList.add("is-active");
  }
  toFirst();
  window.addEventListener("load", toFirst);
  window.addEventListener("pageshow", toFirst);
});